import { useState, useCallback } from 'react'
import apiService from '../services/api'

// Key for storing authentication state (not the token - that's in an HTTP-only cookie)
const AUTH_STATE_KEY = 'isAuthenticated'

export const useAuth = () => {
  // Track if user is authenticated (the actual token is in an HTTP-only cookie)
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    // Check localStorage for auth state flag (set after successful login)
    return localStorage.getItem(AUTH_STATE_KEY) === 'true'
  })

  // Called after successful login/register - the server has set the cookie
  const login = useCallback(() => {
    localStorage.setItem(AUTH_STATE_KEY, 'true')
    setIsAuthenticated(true)
  }, [])

  // Clear authentication state and call logout API to clear the cookie
  const logout = useCallback(async () => {
    try {
      await apiService.logout()
    } catch (error) {
      console.error('Logout API call failed:', error)
      // Continue with local logout even if API call fails
    }

    localStorage.removeItem(AUTH_STATE_KEY)
    localStorage.removeItem('userEmail')
    localStorage.removeItem('username')
    localStorage.removeItem('authToken')
    setIsAuthenticated(false)
    window.location.reload()
  }, [])

  // Force logout (e.g., when API returns 401/403)
  const forceLogout = useCallback(() => {
    localStorage.removeItem(AUTH_STATE_KEY)
    localStorage.removeItem('userEmail')
    localStorage.removeItem('username')
    localStorage.removeItem('authToken')
    setIsAuthenticated(false)
  }, [])

  return {
    isAuthenticated,
    login,
    logout,
    forceLogout,
  }
}
